import { createContext, useState } from 'react'
import { MODAL_STYLES } from 'asterX-UI'
import InfoModal from 'asterX-UI/Modals/InfoModal'
import { deepCopyObject } from 'lib/utils'
import { Typography } from '@material-ui/core'

export const ModalbarContext = createContext({
  /**
   * @function callModalbar
   * callModalbar
   * @param {string} title
   * @param {string|JSX.Element} body
   * @param {object}options
   * @param {string} options.variant
   * @param {function} options.onCloseAction
   *  @example callModalbar('Error ','description',{ variant: 'error'})
   */
  callModalbar: (title, body, options) => {},
  closeModalbar: () => {}
})
const INIT_MODALBAR = {
  open: false,
  variant: MODAL_STYLES.variant.error,
  title: '',
  body: '' || <></>,
  btnText: undefined,
  onCloseAction: () => {}
}
const ModalbarProvider = props => {
  const [modalbar, setModalbar] = useState(INIT_MODALBAR)
  const { open, variant, title, body, onCloseAction, btnText } = modalbar
  /**
   * @function callModalbar
   * callModalbar
   * @param {string} title
   * @param {string|JSX.Element} body
   * @param {object}options
   * @param {string} options.variant
   * @param {function} options.onCloseAction
   *  @example callModalbar('Error ','description',{ variant: 'error'})
   */
  const callModalbar = (
    title = '',
    body = '' || <></>,
    options = { variant: 'error', onCloseAction: () => {}, btnText }
  ) => {
    setModalbar(prevState => ({
      ...prevState,
      title,
      body,
      ...options,
      open: true
    }))
  }

  const closeModalbar = async () => {
    onCloseAction && typeof onCloseAction === 'function' && (await onCloseAction())

    setModalbar(deepCopyObject(INIT_MODALBAR))
  }

  return (
    <ModalbarContext.Provider value={{ callModalbar, closeModalbar }}>
      {props.children}
      {open && (
        <InfoModal open={open} variant={variant} title={title} onClose={closeModalbar} btnText={btnText}>
          {typeof body === 'string' ? (
            <Typography
              variant={'body1'}
              style={{
                background: '#475467',
                color: '#FFFFFF',
                borderRadius: 5,
                overflowY: 'auto',
                maxWidth: 367,
                maxHeight: 320,
                overflowWrap: 'break-word',
                padding: 10
              }}
            >{`${body || ''}`}</Typography>
          ) : (
            body
          )}
        </InfoModal>
      )}
    </ModalbarContext.Provider>
  )
}
export default ModalbarProvider
